import axios from 'axios'
import store  from '../store';

const reservas = {
  getServicesZones(branch_id,scheduleday_id) {
    return axios({
      method: "get",
      url: `${process.env.VUE_APP_API}/api/v4/branch_params.json?type=hours&branch_id=${branch_id}&scheduleday_id=${scheduleday_id}`
    });
  },
  getAvailableHoursZones(branch_id, date, persons) {
    return axios({
      method: 'get',
      url: `${process.env.VUE_APP_API}/api/reservations/v2/available_dates.json?personas=${persons}&date=${date}&branch_id=${branch_id}`
    });
  },
  getDays(branch_id, bookInfo_cuantos) {
    const url = `${process.env.VUE_APP_API}/api/reservations/available_days.json?branch_id=${branch_id}&personas=${bookInfo_cuantos}`;
    return axios({
      method: "get",
      url: url
    });
  },
  getPeople() {
    return axios({
      method: "get",
      url: `${process.env.VUE_APP_API}/api/reservations/available_people.json?branch_id=${store.state.customer.supplier.branch_id}`
    });
  },
  getBranch(reservation_branch_id) {
    const url = `${process.env.VUE_APP_API}/api/reservations/params_by_branch/${reservation_branch_id}.json`;
    return axios({
      method: "get",
      url: url
    });
  },
  GetOrder(purchase_id) {
    return axios({
      method: "get",
      url: `${process.env.VUE_APP_API_EXP}/api/my_purchases/${purchase_id}.json`,
      headers: {
        profileid: store.state.profile.profile.id,
        token: store.state.profile.profile.token
      }
    })
  },
  getBranchDetail(branch_id){
    const url = `${process.env.VUE_APP_API}/api/v4/branch_params.json?branch_id=${branch_id}`;
    return axios({
      method: "get",
      url: url
    });
  },
  getDates(branch_id,bookInfo_cuantos) {
    const url = `${process.env.VUE_APP_API}/api/reservations/available_dates.json?branch_id=${branch_id}&personas=${bookInfo_cuantos}`;
    return axios({
      method: "get",
      url: url
    });
  },
  getHours(bookInfo_scheduleday_id) {
    const url = `${process.env.VUE_APP_API}/api/v4/branch_params.json?type=hours&branch_id=${store.state.customer.supplier.branch_id}&scheduleday_id=${bookInfo_scheduleday_id}`;
    return axios({
      method: "get",
      url: url
    });
  },
  deleteItemList(item,params_id,params_token){
    const url = `${process.env.VUE_APP_API}/api/reservations/guests/${item.id}.json?reservation_id=${params_id}&token=${params_token}`
    return axios({
      method: "delete",
      url: url
    });
  },
  addInvitados(params_id,params_token,obj) {
    const url = `${process.env.VUE_APP_API}/api/reservations/guests.json?reservation_id=${params_id}&token=${params_token}`
    return axios({
      method: "post",
      url: url,
      data: {guests:obj}
    });
  },
  getListInfo(params_id,params_token) {
    const url = `${process.env.VUE_APP_API}/api/reservations/guests.json?reservation_id=${params_id}&token=${params_token}`
    return axios({
      method: "get",
      url: url
    });
  },
  getBookRateInfo(param_id, param_token) {
    const url = `${ process.env.VUE_APP_API }/rate/${ param_id }/${ param_token }`;
    return axios({
      method: "get",
      url: url
    });
  },
  getBookingInfo(params_id,params_token) {
    const url = `${process.env.VUE_APP_API}/api/v4/reservations/${params_id}.json?token=${params_token}`
    return axios({
      method: "get",
      url: url
    });
  },
  cancelBooking(params_id,params_token) {
    const url = `${process.env.VUE_APP_API}/api/reservations/index/${params_id}.json?token=${params_token}`
    return axios({
      method: "delete",
      url: url,
      headers: {
        profileid: store.state.profile.profile.id,
        token: store.state.profile.profile.token
      }
    });
  },
  editarDatos(params_id,params_token,bookInfo) {
    const url = `${process.env.VUE_APP_API}/api/reservations/index/${params_id}.json?token=${params_token}`;
    return axios({
      method: "put",
      url: url,
      data: {
        reservation: bookInfo
      },
      headers: {
        profileid: store.state.profile.profile.id,
        token: store.state.profile.profile.token
      }
    });
  },
  sendInfo(reservation) {
    return axios({
      method: "post",
      url: `${process.env.VUE_APP_API}/api/v4/reservations.json`,
      data: { reservation: reservation }
    })
  }
}

export {
	reservas
}
